import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Event} from '../../../model/Event';
import {Observable} from 'rxjs';
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {DynamicTableComponent} from "../../../components/common/dynamic-table/dynamic-table.component";

@Component({
    selector: 'app-list-events',
    imports: [
        CommonModule,
        DynamicTableComponent,
        BadgeComponent,
        FaIconComponent
    ],
    templateUrl: './list-events.component.html',
    styleUrl: './list-events.component.scss'
})
export class ListEventsComponent {
  @Input('events') events: Observable<Event[]>;

  @Output()
  edit = new EventEmitter<Event>();

  @Output()
  remove = new EventEmitter<Event>();

  tableActions = [
    {
      icon: 'pen',
      eventHandler: (item) => this.edit.emit(item),
      cssClass: 'text-info',
      tooltip: 'Modifier'
    },
    {
      icon: 'trash-alt',
      eventHandler: (item) => this.remove.emit(item),
      cssClass: 'text-danger',
      tooltip: 'Supprimer'
    },
  ];

  // Table headers and sorting ['Aperçu', 'Nom', 'Couleur de fond', 'Couleur de texte', 'Accessibilité']
  tableaHeaders = [
    { label: "Type" },
    {
      label: "Titre",
      sortable: true,
      property: 'title',
    },
    { label: 'Pour' },
    {
      label: 'Début',
      sortable: true,
      property: 'beginDate',
    },
    {
      label: 'Fin',
      sortable: true,
      property: 'endDate',
    },
    { label: 'Visible' }
  ]

  isVisible(d: Event): boolean {
    const currentDate = new Date();
    return new Date(d.beginDate) < currentDate && new Date(d.endDate) > currentDate;
  }
}
